import React from "react";
import * as XLSX from "xlsx";

export default function SearchReports({
  onSearch,
  onFromDate,
  onToDate,
  fromDate,
  toDate,
  reports,
  aggregators = [],
  onAggregatorChange,
  aggregator,
}) {
  const handleExport = async () => {
    try {
      const params = new URLSearchParams({
        fromDate,
        toDate,
        aggregator,
        search: "",
        export: "true",
      });

      const res = await fetch(
        `${process.env.REACT_APP_BACKENDORDERURL}/reports/profit-loss?${params}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      const json = await res.json();

      if (!json.success) {
        alert("Export failed");
        return;
      }

      const data = json.data;

      if (!data.length) {
        alert("No data to export");
        return;
      }

      // Totals
      const totalSubTotal = data.reduce(
        (acc, r) => acc + (Number(r.subTotal) || 0),
        0
      );
      const totalAmount = data.reduce(
        (acc, r) => acc + (Number(r.totalAmount) || 0),
        0
      );

      const wsData = [
        ...data,
        {},
        {
          aggregator: "TOTAL",
          subTotal: totalSubTotal,
          totalAmount: totalAmount,
        },
      ];

      const ws = XLSX.utils.json_to_sheet(wsData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "reports");

      XLSX.writeFile(
        wb,
        `${fromDate || "all"}_${toDate || "all"}_reports.xlsx`
      );
    } catch (err) {
      alert("Export error");
    }
  };

  return (
    <div className="search-controls d-flex gap-2 searchreport">
      <p>From:</p>
      <input
        type="date"
        value={fromDate}
        onChange={(e) => onFromDate(e.target.value)}
        className="search-bar"
      />
      <p>To:</p>
      <input
        type="date"
        value={toDate}
        onChange={(e) => onToDate(e.target.value)}
        className="search-bar"
      />
      <input
        type="text"
        placeholder="Search..."
        className="search-bar"
        onChange={(e) => onSearch(e.target.value)}
      />
      <div>
        <select
          id="aggregatorFilter"
          className="search-bar"
          value={aggregator || ""}
          onChange={(e) => onAggregatorChange(e.target.value)}
        >
          <option value="">All Aggregators</option>
          {aggregators.map((agg) => (
            <option key={agg} value={agg}>
              {agg}
            </option>
          ))}
        </select>
      </div>
      <button className="btn btn-primary" onClick={handleExport}>
        Export
      </button>
    </div>
  );
}
